export enum DocumentSourceEnum {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}
